<template>
  <v-dialog v-model="open" max-width="380">
    <!-- 사인하기 버튼 시작 -->
    <template v-slot:activator="{ on, attrs }">
      <!-- 사인 한 경우 사인 이미지 보여줌 -->
      <div v-if="signUrl" class="px-6 sign-button" v-bind="attrs" v-on="on">
        <v-card :flat="captureMode">
          <v-card-text class="pa-0 white">
            <img class="sign-img" :src="signUrl" />
          </v-card-text>
        </v-card>
      </div>

      <!-- 사인 아직 안했을 때 모달 오픈 버튼 -->
      <div v-else class="width-100 px-6 sign-button">
        <v-btn
          block
          color="white pa-5"
          height="160"
          ref="button"
          v-bind="attrs"
          v-on="on"
          :depressed="captureMode"
          :class="{ 'border-error': showErrorMode }"
        >
          <b :class="showErrorMode ? 'error--text' : 'color--nice-grey'">
            본인의 성함을 정자로 서명해주세요.
          </b>
        </v-btn>
      </div>
    </template>
    <!-- 사인하기 버튼 끝 -->

    <!-- 사인 영역 시작 -->
    <v-card v-if="me">
      <v-card-text>
        <VueSignaturePad
          class="pad"
          ref="signaturePad"
          :options="{
            onBegin: () => {
              $refs.signaturePad.resizeCanvas()
            },
          }"
        />
        <div class="guide">
          <h1 class="f-blue-grey--text">{{ me.name }}</h1>
          <p>본인의 성함을 정자로 서명해주세요.</p>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn depressed height="52" @click="close">취소</v-btn>
        <v-btn depressed height="52" @click="submit">확인</v-btn>
      </v-card-actions>
    </v-card>
    <!-- 사인 영역 끝 -->
  </v-dialog>
</template>

<script>
import { dataURIToBlob } from '@/util'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      open: false,
      signUrl: null,
    }
  },
  watch: {
    open(v) {
      if (this.signUrl && v) {
        this.$refs.signaturePad.clearSignature()
      }
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('ui', ['captureMode', 'showErrorMode']),
  },
  methods: {
    close() {
      this.open = false
    },
    submit() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      if (isEmpty === true) {
        $swal.basic.alert('사인을 해주세요.')
      } else {
        this.signUrl = data
        this.$emit('sign', dataURIToBlob(data))
        this.close()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

// 에러 표시 색상 시작
.v-btn:not(.border-error) {
  outline: 1px solid transparent;
}
.v-btn.border-error {
  outline: 1px solid $red;
}
b,
.v-btn {
  -webkit-transition: all 0.5s ease-out;
  -moz-transition: all 0.5s ease-out;
  -o-transition: all 0.5s ease-out;
  transition: all 0.5s ease-out;
}
// 에러 표시 색상 끝

// 계약서 화면 사인 버튼
.sign-button {
  max-width: 400px;
  margin: 0 auto;
}
// 사인 있을 경우 사인 이미지
.sign-img {
  height: 130px;
}

// 모달
.v-card {
  border-radius: $border-radius-default;

  &__text {
    position: relative;
    padding: 10px !important;
    height: 160px;

    .pad {
      position: relative;
      z-index: 2;
    }

    .guide {
      position: absolute;
      text-align: center;
      bottom: 0;
      width: 100%;
      left: 0;

      h1 {
        font-size: 28px;
        font-weight: 700;
        letter-spacing: 20px;
        margin-bottom: 36px;
        user-select: none;
      }

      p {
        font-size: 12px;
        user-select: none;
      }
    }
  }

  &__actions {
    padding: 0 !important;

    button {
      margin: 0 !important;
      font-size: 20px;
      font-weight: 900;
    }

    button:first-of-type {
      width: 40%;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      color: #727d8c;
      background-color: #d7e1ea;
    }
    button:last-of-type {
      width: 60%;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-bottom-left-radius: 0;
      color: #ffffff;
      background-color: #333333;
    }
  }
}
</style>
